import { LogLevel } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
    authority: process.env.VUE_APP_MSAL_AUTHORITY,
    knownAuthorities: [process.env.VUE_APP_MSAL_KNOWN_AUTHORITY],
    redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI,
    postLogoutRedirectUri: process.env.VUE_APP_MSAL_POST_LOGOUT_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            // console.info(message);
            break;
          case LogLevel.Verbose:
            // console.debug(message);
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

const loginRequest = {
  scopes: (process.env.VUE_APP_MSAL_SCOPES || '').split(' ').map(s => s.trim()).filter(Boolean),
};

export { msalConfig, loginRequest };
